<template>
  <div :class="[$style.__exit__confirm, cfmExit ? [$style.__active] : '']">
    <div :class="[$style.__outer]"></div>
    <div :class="[$style.__exit__container]">
      <div :class="[$style.__header]">
        <h5>{{ $t("messages.notification") }}</h5>
      </div>
      <div :class="[$style.__body]">
        <p>{{ $t("messages.exit.confirm") }}</p>
      </div>
      <div :class="[$style.__footer, 'row-livechat']">
        <div :class="['col-6', 'pr-1']">
          <div @click="exitsChat" :class="['btn', 'btn-success', $style.__btn]">
            {{ $t("button.send") }}
          </div>
        </div>
        <div :class="['col-6', 'pl-1']">
          <div
            @click="cancelExit"
            :class="['btn', 'btn-secondary', $style.__btn]"
          >
            {{ $t("button.cancel") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chathub from "@/apis/chathub";
import Socket from "@/sockets/Socket";
import EventBus from "@/functions/EventBus";

let chathubObject = new Chathub();

export default {
  props: {
    cfmExit: {
      type: Boolean,
      default: false,
    },
    room: {
      type: String,
      default: null,
    },
    token: {
      type: String,
      default: null,
    },
  },

  methods: {
    cancelExit: function () {
      this.$emit("parentcfmExit", false);
    },
    exitsChat: function () {

      if (this.$cookies.get("fpt_livechat")) var chatToken = this.$cookies.get("fpt_livechat").token;
      if (this.$cookies.get("fpt_livechat")) var chatRoom = this.$cookies.get("fpt_livechat").room;

      if (chatToken && chatRoom) {
        this.sendCloseChatMessage(chatToken, chatRoom);
      }

      if (
        this.room != null &&
        this.room != "" &&
        this.token != null &&
        this.token != ""
      ) {
        Socket.close(this.room);
        //khong goi API dong room nua
        //chathubObject.leaveRoom(this.room, this.token);
      }
      this.$cookies.remove("fpt_livechat");
      if (this.$router.currentRoute.path != "/") {
        this.$router.push("/");
      }
      this.$emit("exitChat", true);
      localStorage.setItem("closeChat", true);

      EventBus.$emit("clearErrorList", true);
      if (document.getElementById("formLiveChat")) {
        document.getElementById("formLiveChat").reset();
      }
    },

    sendCloseChatMessage: function (chatToken, chatRoom) {
      var message = "Khách hàng đã rời khỏi cuộc hội thoại";

      var resultSendMessage = chathubObject.sendMessage(
        chatToken,
        chatRoom,
        message
      );
      resultSendMessage
        .then((response) => {
          if (response.data.success) {
            console.log("da gui message ket thuc hoi thoai");
          }
        })
        .catch((error) => {
          var that = this;
          this.status.errorSend = true;
          setTimeout(function () {
            that.status.errorSend = false;
          }, 3000);
        });
    },
  },
};
</script>

<style lang="scss" module scoped>
.__exit__confirm {
  display: none;
  &.__active {
    display: block;
  }
  .__outer {
    background: #000;
    height: 100%;
    width: 100%;
    bottom: 0;
    position: absolute;
    z-index: 9999;
    opacity: 0.5;
  }
  .__exit__container {
    position: absolute;
    z-index: 10000;
    background: #fff;
    bottom: 30%;
    margin: 20px 30px;
    border-radius: 8px;
    padding: 24px;
    .__header {
      h5 {
        font-size: 14px !important;
        font-weight: 500 !important;
      }
      margin-bottom: 20px;
    }
    .__body {
      font-size: 13px !important;
      font-style: normal;
      line-height: 16px;
      margin-bottom: 30px;
    }
    .__footer {
      .__btn {
        font-size: 13px !important;
        font-style: normal;
        line-height: 16px;
        width: 100%;
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .__exit__confirm {
    .__exit__container {
      bottom: 20%;
    }
  }
}
</style>